module.exports = __webpack_public_path__ + "static/media/image3.b9690f7f.png";